var mapAssignmentKeyToParties = function mapAssignmentKeyToParties(assignmentKey, mappings) {
  var _mappings$filter;

  return (_mappings$filter = mappings === null || mappings === void 0 ? void 0 : mappings.filter(function (mapping) {
    return mapping.assignmentKey === assignmentKey;
  })) !== null && _mappings$filter !== void 0 ? _mappings$filter : [];
};

export { mapAssignmentKeyToParties };